import React from 'react';

const Checkbox = props => {
    const {name, onChange, checked = false, className = '', style, color, spinner = false} = props,
        classes = ['form-control', 'checkbox', className],
        checkmarkStyle = {
            borderColor: color,
            backgroundColor: checked ? color : null,
        };

    if (spinner) {
        checkmarkStyle.opacity = 0.3;
    }

    return (
        <label className={classes.join(' ')} style={style}>
            <input name={name} type="checkbox" onChange={e => onChange(e.target.checked)} checked={!!checked} />
            <span className="checkmark" style={checkmarkStyle}></span>
            <span>{props.children}</span>
        </label>
    );
};

export default Checkbox;
